export default __webpack_public_path__ + "static/media/greenStar.24c33784.svg";